import { useSelector } from '@legendapp/state/react';
import { AuthProvider as SharedAuthProvider } from '@tf/shared';
import type React from 'react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { configStore } from '@/core/stores';

export const AuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const config = useSelector(() => configStore.get());
	const navigate = useNavigate();

	const navigation = useMemo(
		() => ({
			routerPush: (to: string) => navigate(to),
			routerReplace: (to: string) => navigate(to, { replace: true }),
		}),
		[navigate],
	);

	return (
		<SharedAuthProvider publishableKey={config.auth.clerk_publishable_key} navigation={navigation}>
			{children}
		</SharedAuthProvider>
	);
};
